<svelte:options customElement={{ tag: "bt-eyebrow-button", shadow: "none", }} />

<script lang="ts">
  import Icon from '$shared/icons/Icon.svelte'

  export let buttonClasses: string = '';
  export let text: string = 'Test';
  export let link: string = '';
  export let icon: string = '';
  export let eyebrow: string = '';
</script>

<a href="{link}" class="p-4 mt-8 bg-neutral-900 text-white hover:bg-transparent hover:text-neutral-900 border group {buttonClasses}">
  <div>
    <span class="text-xs uppercase text-neutral-150 group-hover:text-neutral-750">{eyebrow}</span>
    <span class="text-sm font-medium button-title">{text}</span>
  </div>
  <span class="ml-4">
    {#if icon}
      <Icon icon={icon} size="medium"></Icon>
    {/if}
  </span>
</a>

<style>
  :global(bt-eyebrow-button) {
    display: block;
    container-type: inline-size;
  }
  :global(#learning_path bt-eyebrow-button) {
    container-type: normal;
  }

  .button-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 1.25rem;
    max-height: 2.5rem;
}


  a {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 20rem;

  }

  div {
    display: flex;
    flex-direction: column;
    max-width: 75%;
    text-align: left;
    min-width: 0;
  }
  @media print {
    a {
      display: none !important;
    }
  }
</style>